import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getAll () {
    return Api()
      .get('/v1/admin/roles')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.Role.Messages.LoadingRoleErrorMessage'),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
}
